<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="meunTitle2" :title3="meunTitle3"></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainTitle">
            <div>
              <span class="userName">捐助详情-手动录入</span>
              <div class="rightBtn">
                <el-button-group>
                  <el-button type="primary" size="small" @click="edit()">编辑</el-button>
                </el-button-group>
              </div>
            </div>
            <div class="infos">
              <div class="info2">
                <div class="divStyle">
                  <p>捐助金额</p>
                  <h1>{{ info.money }}</h1>
                </div>
                <div class="divStyle">
                  <p>关联校友</p>
                  <h1 class="name" @click="toUser()">{{ info.name_cn }}</h1>
                </div>
              </div>
            </div>
          </div>
          <el-tabs v-model="activeName" class="elTabs">
            <el-tab-pane label="" name="first">
              <div class="mainbody">
                <div class="baseInfo">
                  <h4>捐助订单</h4>
                  <div class="info">
                    <p>
                      <span>ID:</span>
                      {{ info.id }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>捐助内容:</span>
                      {{ info.content }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>捐助类型:</span>
                      {{ info.type }}
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>捐助时间:</span>
                      {{ info.journal_time }}
                    </p>
                  </div>
                  <div class="info">
                    <p>
                      <span>更新时间:</span>
                      {{ info.record_time }}
                    </p>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info">
                    <p>
                      <span>备注:</span>
                      {{ info.remark }}
                    </p>
                  </div>
                </div>

                <div class="divide_line_style"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayout'
import { response } from '@/utils/resUtils.js'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  data() {
    return {
      tableLoading: false,
      URL_PATH: URL_PATH,
      userid: '',
      meunItem: null,
      meunTitle: '校友基本信息列表',
      meunTitle2: '捐助详情',
      meunTitle3: '捐助详情',
      activeName: 'first',
      info: {} //个人信息
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.userid = this.meunItem.userid
      if (this.$route.query.list) {
        // 捐助列表进入
        this.meunTitle3 = null
      } else {
        // 用户详情进入
        this.meunTitle2 = '校友详情'
      }
      this.getInfo()
    },
    // 编辑
    edit() {
      Api.verifyApi(CApi.api_updateAisJournal, verify => {
        if (verify) {
          this.$router.push({
            path: '/data/journal-details-manual-add',
            query: {
              id: this.$route.query.id
            }
          })
        }
      })
    },
    // 获取信息
    getInfo: function () {
      this.tableLoading = true
      this.$api
        .getDonationInfo({
          token: localStorage.getItem('token'),
          id: this.$route.query.id
        })
        .then(({ data }) => {
          this.info = data.Data
          this.tableLoading = false
        })
        .catch(({ error }) => {
          this.tableLoading = false
        })
    },
    // 跳转用户详情
    toUser() {
      Api.verifyApi(CApi.api_getAisInfoById, verify => {
        if (verify) {
          this.meunItem.userid = this.info.ais_info_id
          localStorage.setItem('meunItem', JSON.stringify(this.meunItem))
          this.$router.push('/data/user-details')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -10px;
  margin-left: -20px;
  margin-right: -20px;
}
.mainTitle .userName {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .rightBtn {
  float: right;
}
.mainTitle .infos {
  width: 100%;
  float: left;
}
.mainTitle .infos span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .infos p {
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainTitle .infos h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .info1 {
  width: 35%;
  float: left;
}
.mainTitle .info2 {
  width: 20%;
  float: right;
}
.mainTitle .info2 .divStyle {
  width: 50%;
  float: right;
}
.mainTitle .info2 .divStyle p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
  // float: right;
}
.mainTitle .info2 .divStyle h1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .info2 .divStyle .name {
  cursor: pointer;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #4d8bf8;
}
.elTabs {
  margin-top: -40px;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 36px 32px;
  height: 60vh;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .baseInfo {
  width: 100%;
  float: left;
  margin-top: 32px;
}
.mainbody .info {
  width: 360px;
  float: left;
}
.mainbody .info h4 {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info .h4place {
  margin-top: 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}

.mainbody .info span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
}
.mainbody .info p {
  margin-top: 16px;
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainbody .info .pplace {
  margin-top: 16px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #00000000;
}
.mainbody .tableInfo {
  margin-top: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.divide_line_style {
  width: 100%;
  height: 0.5px;
  background: #f0f0f0;
  float: left;
  margin-top: 48px;
}
</style>


// WEBPACK FOOTER //
// src/pages/dataMgr/journalDetailsManual.vue